<template>
  <Flex
    :gap="0.5"
    align="end"
  >
    <BaseInput
      v-model="digits"
      :required="required"
      :disabled="disabled"
      :label="t('register.salonized_pay.new_onboarding.vat_number')"
      :error="error"
      :regex="disabled ? undefined : CH_REGISTRATION_NUMBER_REGEX"
      placeholder="CHE-123.456.789"
      v-test="'sp-onboarding-input-vatNumber'"
    />
    <BaseDropdown
      v-model="suffix"
      :required="required"
      :disabled="disabled"
      :options="suffixOptions"
      small
      v-test="'sp-onboarding-input-vatSuffix'"
    />
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatSwissRegistrationNumber } from '@/helpers/formatting';
import { CH_REGISTRATION_NUMBER_REGEX } from '@/helpers/regex';

const { t } = useI18n();

const props = defineProps<{
  modelValue: string;
  companyLanguage?: string;
  required?: boolean;
  disabled?: boolean;
  error?: string | null;
}>();

const emit = defineEmits<(e: 'update:modelValue', value: string) => void>();

const suffixOptions = [
  { label: 'MWST', value: 'MWST' },
  { label: 'TVA', value: 'TVA' },
  { label: 'IVA', value: 'IVA' },
];

const suffixByLanguage: Record<string, string> = {
  de: 'MWST',
  fr: 'TVA',
  it: 'IVA',
};

const existingSuffix = props.modelValue.match(/(MWST|TVA|IVA)/i);
const digits = ref(formatSwissRegistrationNumber(props.modelValue));
const suffix = ref(
  existingSuffix
    ? existingSuffix[1].toUpperCase()
    : suffixByLanguage[props.companyLanguage ?? ''] || 'MWST',
);

watch(digits, (val) => {
  const formatted = formatSwissRegistrationNumber(val);
  if (formatted !== val) {
    digits.value = formatted;
  }
});

watch([digits, suffix], ([newDigits, newSuffix]) => {
  emit('update:modelValue', newDigits ? `${newDigits} ${newSuffix}` : '');
});
</script>
